import ComponentManager from "./componentFramework";

declare function require(moduleName: string): any;

// TODO (Michael) Make this based on environment deployed to.
// 		Do we set "javax.faces.PROJECT_STAGE"? See: https://docs.oracle.com/javaee/6/tutorial/doc/bnaxj.html#giqxl
//		I believe Primefaces will set the following based on that.
(window as any).PrimeFaces.settings.projectStage = "Development";

// Library code (inits upon import)
import "./scripts/jsf/JsfViewStateFix";
import "./scripts/jsf/JsfAjax";
import JsfAjaxStatus from "./scripts/jsf/JsfAjaxStatus";

// jQuery -- TODO (Michael): Get rid of this in the end.
import * as $ from "jquery";
(window as any).$ = (window as any).$ ?? $;

import CmsInterface from "./scripts/CmsInterface";

// Components
import "./components/JsonScript";
import "./components/JsfJsCommand";

import "./components/Button";
import "./components/AutosizeTextarea";
import "./components/DateTimePicker";
import "./components/FullscreenButton";
import "./components/Wysiwyg";
import "./components/Tooltip";
import "./components/ExternalLinkField";
import "./components/Expandable";
import "./components/InlineMenu";

import "./components/Dialog";
import "./components/UploadFilesDialog";

import "./components/Message";
import "./components/Messages";

import "./components/GeographicMap";
import "./components/GeographicMapControls";

import "./components/AjaxStatusScreenBlocker";

import "./components/EditContentAjaxStatus";
import "./components/EditContentNodeControls";
import "./components/EditContentNode";
import "./components/EditContentGroup";
import "./components/EditContentAction";
import "./components/EditContentNodes";
import "./components/EditContent";

import "./components/SearchResults";
import "./components/SearchResult";

import "./components/PrimeFaces";

import "./components/RadioSelectableOptions";

import "./components/DynamicExecuteButton"

// Components related to views
import "./components/SiteEditor";
import "./components/SiteChecks";

import "./components/PanelLayout";

import "./scripts/SessionExistenceChecker";

// Make ComponentManger accessible
// TODO @Michael: Get rid of this?
CmsInterface.getInstance().set("ComponentManager", ComponentManager);

// This adds a fix for PrimeFaces preventing non-PrimeFaces checkboxes from working within their datatables... Mostly becaues PrimeFaces checkboxes aren't actually checkboxes.
jQuery(document).on('click', '.wrapsCheckboxBrokenByPrimefaces', event => {
	const ele = event.currentTarget.querySelector('input');
	ele.hasAttribute('checked') ? ele.removeAttribute('checked') : ele.setAttribute('checked', 'checked')
});


